import { render, staticRenderFns } from "./HeaderNotificationListItem.vue?vue&type=template&id=d0019d54&scoped=true&"
import script from "./HeaderNotificationListItem.vue?vue&type=script&lang=js&"
export * from "./HeaderNotificationListItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotificationListItem.vue?vue&type=style&index=0&id=d0019d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0019d54",
  null
  
)

export default component.exports